var map = {
	"./icon-file.svg": "7eaa",
	"./input_icon_fb.svg": "7592",
	"./input_icon_telegram.svg": "0f54",
	"./input_icon_wechat.svg": "2c5f",
	"./input_icon_whatsapp.svg": "a491",
	"./mes.svg": "e556",
	"./nem-sems-a.svg": "b58e",
	"./realname.svg": "9723",
	"./sprite.svg": "cb7e",
	"./svg.svg": "89b1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";